/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Pim.Api | rt-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner } from './AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner';
import {
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON,
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSONTyped,
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON,
    AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSONTyped,
} from './AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner';

/**
 * An export, as sent in realtime notifications.
 * @export
 * @interface ExportNotificationPayloadExportsInner
 */
export interface ExportNotificationPayloadExportsInner {
    /**
     * Id of the company the export belongs to.
     * @type {string}
     * @memberof ExportNotificationPayloadExportsInner
     */
    companyId: string;
    /**
     * Kind of export.
     * @type {ExportNotificationPayloadExportsInnerTypeEnum}
     * @memberof ExportNotificationPayloadExportsInner
     */
    type: ExportNotificationPayloadExportsInnerTypeEnum;
    /**
     * Current status of the export.
     * @type {ExportNotificationPayloadExportsInnerStatusEnum}
     * @memberof ExportNotificationPayloadExportsInner
     */
    status: ExportNotificationPayloadExportsInnerStatusEnum;
    /**
     * Id of the asset holding the exported file; `null` until the export has produced it.
     * @type {string}
     * @memberof ExportNotificationPayloadExportsInner
     */
    resultFileId?: string | null;
    /**
     * Id of the user who requested the export.
     * @type {string}
     * @memberof ExportNotificationPayloadExportsInner
     */
    ownerId: string;
    /**
     * Id of the background job processing the export, if any.
     * @type {string}
     * @memberof ExportNotificationPayloadExportsInner
     */
    jobId?: string | null;
    /**
     * Companies that own the export, with the permissions each has on it.
     * @type {Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>}
     * @memberof ExportNotificationPayloadExportsInner
     */
    ownedByCompanies: Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>;
    /**
     * Groups that own the export, with the permissions each has on it.
     * @type {Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>}
     * @memberof ExportNotificationPayloadExportsInner
     */
    ownedByGroups: Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>;
    /**
     * Id of the resource.
     * @type {string}
     * @memberof ExportNotificationPayloadExportsInner
     */
    id: string;
    /**
     * Id of the user who created the resource.
     * @type {string}
     * @memberof ExportNotificationPayloadExportsInner
     */
    createdBy: string;
    /**
     * Id of the user who last updated the resource.
     * @type {string}
     * @memberof ExportNotificationPayloadExportsInner
     */
    updatedBy: string;
    /**
     * When the resource was created.
     * @type {Date}
     * @memberof ExportNotificationPayloadExportsInner
     */
    createdAt: Date;
    /**
     * When the resource was last updated.
     * @type {Date}
     * @memberof ExportNotificationPayloadExportsInner
     */
    updatedAt: Date;
    /**
     * The users and service accounts the resource is shared with, and their permissions on it.
     * @type {Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>}
     * @memberof ExportNotificationPayloadExportsInner
     */
    ownedByUsers: Array<AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInner>;
    /**
     * The permissions of the current user on the resource.
     * @type {Array<ExportNotificationPayloadExportsInnerAgentPermissionsEnum>}
     * @memberof ExportNotificationPayloadExportsInner
     */
    agentPermissions?: Array<ExportNotificationPayloadExportsInnerAgentPermissionsEnum> | null;
}


/**
 * @export
 */
export const ExportNotificationPayloadExportsInnerTypeEnum = {
    As400: 'as400',
    PimCsv: 'pimCsv',
    InDesign: 'inDesign'
} as const;
export type ExportNotificationPayloadExportsInnerTypeEnum = typeof ExportNotificationPayloadExportsInnerTypeEnum[keyof typeof ExportNotificationPayloadExportsInnerTypeEnum];

/**
 * @export
 */
export const ExportNotificationPayloadExportsInnerStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Failed: 'failed',
    Canceled: 'canceled',
    Completed: 'completed'
} as const;
export type ExportNotificationPayloadExportsInnerStatusEnum = typeof ExportNotificationPayloadExportsInnerStatusEnum[keyof typeof ExportNotificationPayloadExportsInnerStatusEnum];

/**
 * @export
 */
export const ExportNotificationPayloadExportsInnerAgentPermissionsEnum = {
    List: 'list',
    Create: 'create',
    Update: 'update',
    Delete: 'delete',
    Share: 'share'
} as const;
export type ExportNotificationPayloadExportsInnerAgentPermissionsEnum = typeof ExportNotificationPayloadExportsInnerAgentPermissionsEnum[keyof typeof ExportNotificationPayloadExportsInnerAgentPermissionsEnum];


/**
 * Check if a given object implements the ExportNotificationPayloadExportsInner interface.
 */
export function instanceOfExportNotificationPayloadExportsInner(value: object): value is ExportNotificationPayloadExportsInner {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('ownedByCompanies' in value) || value['ownedByCompanies'] === undefined) return false;
    if (!('ownedByGroups' in value) || value['ownedByGroups'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('ownedByUsers' in value) || value['ownedByUsers'] === undefined) return false;
    return true;
}

export function ExportNotificationPayloadExportsInnerFromJSON(json: any): ExportNotificationPayloadExportsInner {
    return ExportNotificationPayloadExportsInnerFromJSONTyped(json, false);
}

export function ExportNotificationPayloadExportsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportNotificationPayloadExportsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'type': json['type'],
        'status': json['status'],
        'resultFileId': json['resultFileId'] == null ? undefined : json['resultFileId'],
        'ownerId': json['ownerId'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'ownedByCompanies': ((json['ownedByCompanies'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON)),
        'ownedByGroups': ((json['ownedByGroups'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON)),
        'id': json['id'],
        'createdBy': json['createdBy'],
        'updatedBy': json['updatedBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'ownedByUsers': ((json['ownedByUsers'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerFromJSON)),
        'agentPermissions': json['agentPermissions'] == null ? undefined : json['agentPermissions'],
    };
}

export function ExportNotificationPayloadExportsInnerToJSON(json: any): ExportNotificationPayloadExportsInner {
    return ExportNotificationPayloadExportsInnerToJSONTyped(json, false);
}

export function ExportNotificationPayloadExportsInnerToJSONTyped(value?: ExportNotificationPayloadExportsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'type': value['type'],
        'status': value['status'],
        'resultFileId': value['resultFileId'],
        'ownerId': value['ownerId'],
        'jobId': value['jobId'],
        'ownedByCompanies': ((value['ownedByCompanies'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON)),
        'ownedByGroups': ((value['ownedByGroups'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON)),
        'id': value['id'],
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'ownedByUsers': ((value['ownedByUsers'] as Array<any>).map(AiFieldContentGenerationNotificationPayloadAiGenerationsInnerOwnedByCompaniesInnerToJSON)),
        'agentPermissions': value['agentPermissions'],
    };
}

